/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React from 'react';
import Menu from '@mui/material/Menu';
import { Button, MenuItem } from '@mui/material';
import { CourseMenuViewModel } from './CourseMenuViewModel';
import { useViewModel } from '../../../../../hooks/useViewModel';
import { Pages } from '../../../../../navigation/Pages';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CoursesViewStyles from '../CoursesViewStyles';
import { useLocation } from 'react-router-dom';

interface Props {
	courseId: string;
}

const CourseMenuView = observer((props: Props) => {
	const { classes } = CoursesViewStyles();
	const viewModel: CourseMenuViewModel = useViewModel(CourseMenuViewModel);
	const { courseId } = props;
	const location = useLocation();
	const url = location.pathname.split('/').slice(0, -1).join('/');

	return (
		<>
			<Button className={classes.courseMenu} aria-describedby={'course-menu'} onClick={viewModel.menu.toggleMenu}>
				<MoreHorizIcon fontSize={'small'} fontWeight='bold' color='secondary' />
			</Button>
			<Menu
				id='course-menu'
				anchorEl={viewModel.menu.anchor}
				keepMounted
				open={viewModel.menu.open}
				onClose={viewModel.menu.closeMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
				<MenuItem
					onClick={() => {
						viewModel.navigateTo(`${url}/courses/${courseId}${Pages.STUDENT_MANAGEMENT}`);
					}}>
					<FormattedMessage id='courses.menu.manage_students' />
				</MenuItem>
			</Menu>
		</>
	);
});
export default CourseMenuView;
